/* Cart path through PreviewCart. Opens the drawer only after a successful add, and never with the refresh flag. -- SG 20261026 */

import { PreviewCart } from "../cart/preview-cart";

export interface CartLine {
  id: number;
  quantity: number;
  properties: Record<string, string>;
}

export interface CartAddResult {
  ok: boolean;
  description: string;
  discountApplied: boolean;
}

function emit(name: string, detail: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const target = window as unknown as { dataLayer?: Array<Record<string, unknown>> };
  target.dataLayer = target.dataLayer || [];
  target.dataLayer.push({ event: name, ...detail });
}

async function writeAttributes(kitId: string): Promise<void> {
  await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ attributes: { sleep_finder: "true", sleep_finder_kit: kitId } }),
  });
}

async function applyDiscount(cart: PreviewCart, code: string): Promise<boolean> {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ discount: code, sections: cart.parentSectionId }),
  });
  const data = await response.json();
  const codes = Array.isArray(data.discount_codes) ? data.discount_codes : [];
  const applied = codes.some((row: any) => String(row.code).toLowerCase() === code.toLowerCase() && row.applicable === true);
  if (!applied) return false;
  emit("finder_discount_applied", { code });
  if (data.sections) cart.refreshPreviewCart(data);
  else cart.updateCartHTML();
  return true;
}

export async function addKitToCart(lines: CartLine[], kitId: string, discountCode: string): Promise<CartAddResult> {
  const cart = document.querySelector("preview-cart") as PreviewCart | null;
  if (!cart) {
    return { ok: false, description: "", discountApplied: false };
  }

  const data: any = await cart.addItems(lines);
  if (data && typeof data.status === "number" && data.status >= 400) {
    return { ok: false, description: data.description || "", discountApplied: false };
  }

  try {
    await writeAttributes(kitId);
  } catch (error) {
    console.warn("SleepFinder cart attributes", error);
  }

  // The kit is in the cart from here on, so a drawer render problem must not report the add as failed -- EZ 20261028
  try {
    cart.refreshPreviewCart(data);
    cart.openPreviewCart();
  } catch (error) {
    console.warn("SleepFinder cart drawer", error);
  }

  let discountApplied = false;
  if (discountCode) {
    try {
      discountApplied = await applyDiscount(cart, discountCode);
    } catch (error) {
      console.warn("SleepFinder discount", error);
    }
  }

  emit("finder_add_kit", { items: lines.length });
  return { ok: true, description: "", discountApplied };
}
